import React, { FC } from 'react'

export const Icon3: FC = () => (
  <svg
    width="81"
    height="85"
    viewBox="0 0 81 85"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M46.1795 31.7042H13.417C12.0806 31.7042 11.0026 30.6517 11.0026 29.3462C11.0026 28.0581 12.0806 26.9875 13.417 26.9875H46.1795C47.5012 26.9875 48.5941 28.0581 48.5941 29.3462C48.5941 30.6517 47.5012 31.7042 46.1795 31.7042ZM46.1795 46.0338H13.417C12.0806 46.0338 11.0026 44.9812 11.0026 43.6758C11.0026 42.3696 12.0806 41.3185 13.417 41.3185H46.1795C47.5012 41.3185 48.5941 42.3696 48.5941 43.6758C48.5941 44.9812 47.5012 46.0338 46.1795 46.0338ZM34.86 60.3821H13.417C12.0806 60.3821 11.0026 59.3123 11.0026 58.0241C11.0026 56.7007 12.0806 55.6661 13.417 55.6661H34.86C36.1965 55.6661 37.2745 56.7007 37.2745 58.0241C37.2745 59.3123 36.1965 60.3821 34.86 60.3821ZM13.417 12.6579H29.802C31.1163 12.6579 32.2166 13.7098 32.2166 15.0159C32.2166 16.3214 31.1163 17.3739 29.802 17.3739H13.417C12.0806 17.3739 11.0026 16.3214 11.0026 15.0159C11.0026 13.7098 12.0806 12.6579 13.417 12.6579ZM58.7839 17.3739H43.6099C42.2734 17.3739 41.1954 16.3214 41.1954 15.0159V0.23175H5.29473C2.82111 0.23175 0.812744 2.19133 0.812744 4.60336V68.4179C0.812744 70.83 2.82111 72.7896 5.29473 72.7896H38.2418L38.6479 70.4676C38.8177 69.4517 39.246 68.4914 39.8958 67.6557L58.7839 43.603V17.3739Z"
      fill="#262A44"
    />
    <path
      d="M43.7312 70.5214C43.5618 70.7349 43.4513 70.9857 43.4071 71.2494L41.5068 82.3176C41.4036 82.9141 41.6467 83.5192 42.1402 83.8901C42.4422 84.1165 42.8031 84.2314 43.1714 84.2314C43.3997 84.2314 43.6354 84.184 43.8564 84.087L54.3452 79.4832C54.603 79.3704 54.824 79.1986 54.9934 78.9837L55.8184 77.9345L44.5635 69.465L43.7312 70.5214Z"
      fill="#4E97EA"
    />
    <path
      d="M78.7687 41.4987L74.6473 38.3932C73.6921 37.6741 72.5039 37.3615 71.3156 37.5171C70.1197 37.6697 69.0517 38.2685 68.3222 39.2012L47.4971 65.7214L58.7558 74.1909L79.596 47.6487C81.1001 45.7305 80.7316 42.9722 78.7687 41.4987Z"
      fill="#4E97EA"
    />
  </svg>
)
